import {
	IconButton,
	Sidebar,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
	ReceiptListItem,
} from '../../components';
import styles from '../../assets/styles/Invoice/Invoice.module.scss';

import { ReceiptSummaryContainer } from '../../containers';
import React from 'react';

const NewReceiptMultiple = ({ receiptSummary, goToReceiptSummary }) => {
	return (
		<div>
			{!receiptSummary && (
				<div>
					<MimaText variant="small" align="center">
						Create Receipt for
					</MimaText>
					<MimaText variant="subtitleBold" align="center" mb={4}>
						Funmi Lawal
					</MimaText>
					<ReceiptListItem
						service="Hermes Bag"
						quantity={2}
						amount={10000000}
						date="12/07/22"
					/>

					<MimaButton
						title="Generate Receipt"
						mt={3}
						onClick={goToReceiptSummary}
					/>
				</div>
			)}

			{receiptSummary && <ReceiptSummaryContainer />}
		</div>
	);
};

export default NewReceiptMultiple;
